// extracted by mini-css-extract-plugin
export var calendarView = "_kk-0";